(function () {
  function isDiscountForm(form) {
    return (
      form.hasAttribute('data-discount-form') ||
      form.id === 'CartDrawerDiscountForm' ||
      !!form.querySelector('input[name="discount"]')
    );
  }

  function handleDiscountSubmit(form) {
    var input = form.querySelector('[data-discount-input], input[name="discount"]');
    var messageEl =
      form.parentElement.querySelector('[data-discount-message]') ||
      form.parentElement.querySelector('.cart-drawer-discount-message, .cart-discount-message');
    if (!input) return;

    var code = input.value.trim();
    if (!code) return;

    if (messageEl) { messageEl.hidden = true; messageEl.textContent = ''; }

    var formData = new FormData();
    formData.append('discount', code);

    fetch('/cart/update.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Network error');
        return res.json();
      })
      .then(function (cart) {
        var discountApplied =
          Array.isArray(cart.discount_codes) &&
          cart.discount_codes.some(function (dc) {
            return dc.code && dc.code.toLowerCase() === code.toLowerCase() && dc.applicable;
          });

        if (messageEl) {
          messageEl.textContent = discountApplied ? 'Discount applied!' : 'This discount code is not applicable.';
          messageEl.hidden = false;
        }

        return refreshForForm(form);
      })
      .catch(function (error) {
        console.error(error);
        if (messageEl) {
          messageEl.textContent = 'Could not apply discount. Please try again.';
          messageEl.hidden = false;
        }
      });
  }

  function refreshForForm(form) {
    var drawer = form.closest('cart-drawer');
    if (drawer) {
      return refreshSection('cart-drawer', 'cart-drawer', drawer);
    }
    var footerEl = document.getElementById('main-cart-footer');
    var itemsEl = document.getElementById('main-cart-items');
    var promises = [];
    if (itemsEl) promises.push(refreshSection(itemsEl.getAttribute('data-id'), '#main-cart-items', itemsEl));
    if (footerEl) promises.push(refreshSection(footerEl.getAttribute('data-id'), '#main-cart-footer', footerEl));
    if (!promises.length) { window.location.reload(); return Promise.resolve(); }
    return Promise.all(promises);
  }

  function refreshSection(sectionId, selector, currentEl) {
    if (!sectionId || !currentEl) return Promise.resolve();
    return fetch('/?sections=' + sectionId, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load section: ' + sectionId);
        return res.json();
      })
      .then(function (sectionsHtml) {
        var html = sectionsHtml[sectionId];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newEl = doc.querySelector(selector);
        if (newEl) {
          currentEl.innerHTML = newEl.innerHTML;
          currentEl.classList.toggle('is-empty', newEl.classList.contains('is-empty'));
        }
      })
      .catch(function (error) {
        console.error('Error refreshing section ' + sectionId + ':', error);
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form');
    if (!form || !isDiscountForm(form)) return;

    event.preventDefault();
    event.stopPropagation();
    handleDiscountSubmit(form);
  }, true); 
})();